/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import MemberAdd from "./MemberAdd";
import MemberEdit from "./MemberEdit";
import pr from "../lib/pr";
import { loginState, configState } from "../lib/State";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Member() {
  const [login, setLogin] = useState(loginState);
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(-1);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");

  // 세션 로그인
  const get_session = async () => {
    const token = localStorage.getItem("token");
    const cid = configState.cid;
    let result = await axios.post(configState.api + "/hr/get_session", {
      cid: cid,
      token: token,
    });
    setLogin({ ccid: result.data.ccid, level: result.data.level });

    if (result.data.level !== "manager") {
      window.location.href = "/";
    } else {
      setLoaded(true);
    }
  };

  useEffect(() => {
    get_session();
  }, []);

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "no", headerName: "번호", width: 90, align: "center" },
    { field: "name", headerName: "이름", width: 130 },
    { field: "phonef", headerName: "연락처", width: 130 },
    { field: "sex", headerName: "성별", width: 90, align: "center" },
    {
      field: "age",
      headerName: "나이",
      width: 90,
      align: "center",
    },
    {
      field: "weight",
      headerName: "몸무게",
      width: 90,
      align: "center",
    },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Snow",
  //     phone: "000-0000-0000",
  //     sex: "남",
  //     age: 35,
  //     weight: 55,
  //   }
  // ];

  const onCloseAddPop = () => {
    setShowAdd(false);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const onAddPopOpen = () => {
    setShowAdd(true);
  };

  useEffect(()=>{
    if(login.ccid !== undefined) {
      member_all();
    }
  },[login.ccid]);

  // 리스트
  const member_all = async () => {    
    let result = await axios.post(configState.api + "/hr/member_all", {
       token: token,
       ccid: login.ccid,
       level: login.level,
    });
    if (result.data.success === 1) {
      setRows(result.data.rows);
    }
    else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // 수정팝업
  useEffect(() => {
    if (seq > -1) {
      setShowEdit(true);
    }
  }, [seq]);

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>
          <h3>회원관리</h3>
          <div
            css={css`
              text-align: right;
              max-width: 900px;
              margin-bottom: 15px;
            `}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={onAddPopOpen}
            >
              회원등록
            </Button>
          </div>

          <DataGrid
            css={css`
              max-width: 900px;
              min-height: 400px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onCellClick={(p, e) => {
              setSeq(p.id);
            }}
          />

          <Dialog
            open={showAdd}
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <MemberAdd login={login} onCloseAddPop={onCloseAddPop}></MemberAdd>
          </Dialog>

          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <MemberEdit
              login={login}
              i_seq={seq}
              onCloseEditPop={onCloseEditPop}
            ></MemberEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default Member;
